import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { ThemeState } from '../store/model/theme.model';
import { loadTheme, setDarkMode, setFont, setPrimaryColor } from '../store/action/theme.action';
import { selectFont, selectPrimaryColorPalette } from '../store/selector/theme.selector';

@Injectable({
  providedIn: 'root'
})
export class ThemeInitializerService {
  private renderer: Renderer2;
  private readonly THEME_KEY = 'user-theme'; // Local Storage Key

  constructor(private store: Store,private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initializeTheme(): void {
    const savedTheme = localStorage.getItem(this.THEME_KEY);
    // console.log("savedTheme",savedTheme);
    
    if (savedTheme) {
      const theme: ThemeState = JSON.parse(savedTheme);
      this.applyTheme(theme);
    } else {
      const defaultTheme: ThemeState = {
        primaryColor: 'default',
        font: 'Inter',
        darkMode: false,
        colorPalette: {},
        fontStyles: {},
      };
      this.applyTheme(defaultTheme);
    }
  }

  applyTheme(theme: ThemeState): void {
    this.store.dispatch(setPrimaryColor({ color: theme.primaryColor }));
    this.store.dispatch(setFont({ font: theme.font }));
    this.store.dispatch(setDarkMode({ darkMode: theme.darkMode }));

    this.store.select(selectPrimaryColorPalette).subscribe((palette) => {
      if (!palette || Object.keys(palette).length === 0) {
        // console.error("Palette is empty or undefined!");
        return;
      }
      Object.keys(palette).forEach((shade: any) => {
        document.documentElement.style.setProperty(`--primary-${shade}`, palette[shade]);
      });
    });

    this.store.select(selectFont).subscribe((font) => {
      if (!font) {
        // console.error("Font is empty or undefined!");
        return;
      }
      document.body.style.fontFamily = font;
    });

    localStorage.setItem(this.THEME_KEY, JSON.stringify(theme));
  }

  updateTheme(theme: Partial<ThemeState>): void {
    const currentTheme = JSON.parse(localStorage.getItem(this.THEME_KEY) || '{}');
    const newTheme = { ...currentTheme, ...theme };
    this.applyTheme(newTheme);
  }
}
